export const translations = {
  de: {
    nav: {
      products: "Produkte",
      projects: "Projekte",
      services: "Service",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Beratung anfragen",
      home: "Start",
    },
    hero: {
      eyebrow: "Bodenbeläge · Mülheim an der Ruhr · Seit 1985",
      title_l1: "Böden, die",
      title_l2: "Räume erzählen.",
      subtitle:
        "Vom Familienbetrieb für das Ruhrgebiet — wir beraten, liefern und verlegen Parkett, Vinyl, Laminat und Teppich mit Handwerkstradition.",
      cta_primary: "Showroom besuchen",
      cta_secondary: "Kostenlose Beratung",
      scroll: "Scrollen",
      slides: [
        { tag: "Parkett", title: "Echtholz. Geboren aus dem Wald.", caption: "Eiche · Esche · Räuchernuance" },
        { tag: "Vinyl & Designboden", title: "Leise, langlebig, beeindruckend.", caption: "Wasserfest · klickbar · pflegeleicht" },
        { tag: "Teppich", title: "Wärme unter den Füßen.", caption: "Wolle · Sisal · maßgefertigt" },
        { tag: "Laminat", title: "Charakter ohne Kompromisse.", caption: "Premium HDF · AC5 belastbar" },
      ],
    },
    stats: {
      years: "Jahre Handwerk",
      projects: "verlegte Projekte",
      rating: "Google Bewertung",
      reviews: "zufriedene Stimmen",
    },
    products: {
      eyebrow: "Sortiment",
      title: "Fünf Welten unter Ihren Füßen.",
      subtitle:
        "Von der robusten Eichendiele bis zum samtweichen Wollteppich — alles aus einer Hand, kuratiert für das Ruhrgebiet.",
      items: [
        { name: "Parkett", desc: "Echtholz-Dielen, geölt oder lackiert. Maßgenaue Verlegung inklusive." },
        { name: "Vinyl", desc: "Wasserfest, leise und unverwüstlich. Für Küche, Bad, Büro." },
        { name: "Laminat", desc: "Premium HDF-Träger, AC5-Klassen, hochauflösende Dekore." },
        { name: "Teppich", desc: "Auslegware und Einzelstücke. Wolle, Sisal, Loop und Hochflor." },
        { name: "Designboden", desc: "Mineralisch verstärkt. Authentische Optik, hohe Stabilität." },
      ],
      explore: "Sortiment ansehen",
    },
    marquee: ["Verlegeservice", "Beratung im Showroom", "Lieferung Ruhrgebiet", "Aufmaß vor Ort", "Musterservice", "Pflege & Reparatur"],
    services: {
      eyebrow: "Leistungen",
      title: "Vom ersten Skizzieren bis zum letzten Sockelpaneel.",
      items: [
        {
          name: "Persönliche Beratung",
          desc: "Im Showroom Schultenhofstraße 46 oder bei Ihnen Zuhause — wir bringen Muster, Pläne und Ideen mit.",
        },
        {
          name: "Aufmaß & Planung",
          desc: "Millimetergenau dokumentiert. Wir kalkulieren ehrlich — ohne versteckte Quadratmeter.",
        },
        {
          name: "Verlegeservice",
          desc: "Eigenes Team mit Meisterprüfung. Sauber, pünktlich, mit Bauschutzgarantie.",
        },
        {
          name: "Lieferung",
          desc: "Ganzes Ruhrgebiet. Termingerecht angeliefert — oder Abholung am Showroom.",
        },
        {
          name: "Pflege & Reparatur",
          desc: "Schleifen, Ölen, einzelne Dielen tauschen — wir verlängern die Lebenszeit Ihres Bodens.",
        },
        {
          name: "Barrierefrei",
          desc: "Rollstuhlgerechter Eingang, Parkplatz und Sitzgelegenheit — Beratung für alle.",
        },
      ],
    },
    gallery: {
      eyebrow: "Projekte",
      title: "Räume, die wir mitgestalten durften.",
      subtitle: "Eine Auswahl umgesetzter Böden aus Mülheim, Duisburg, Essen, Oberhausen.",
      filter_all: "Alle",
    },
    testimonials: {
      eyebrow: "Stimmen",
      title: "4,5 von 5 — aus 220 Google-Bewertungen.",
      items: [
        {
          name: "M. Schäfer",
          role: "Privatkundin, Mülheim",
          text: "Persönliche Beratung, faires Angebot und das Verlegeteam war ein Traum. Unser Eichenparkett ist eine Wucht.",
        },
        {
          name: "Architekturbüro Vogel",
          role: "Geschäftskunde",
          text: "Pünktlich, sauber, präzise. Wir empfehlen Pick Bodenbeläge bei jedem Projekt im Ruhrgebiet weiter.",
        },
        {
          name: "Familie K.",
          role: "Renovierung Altbau",
          text: "Endlich ein Fachgeschäft mit echter Beratung. Statt Massenware bekamen wir genau den passenden Boden.",
        },
        {
          name: "Café Kleinod",
          role: "Gastronomie",
          text: "Designboden, der dem Trubel standhält. Die Crew hat über Nacht verlegt — wir haben keinen Tag geschlossen.",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Sprechen wir über Ihren Boden.",
      address_label: "Showroom",
      address: "Schultenhofstraße 46\n45475 Mülheim an der Ruhr",
      phone_label: "Telefon",
      phone: "+49 208 73068",
      hours_label: "Öffnungszeiten",
      hours: "Mo–Fr · 09:00 – 18:00\nSa · 10:00 – 14:00",
      access_label: "Barrierefreiheit",
      access: "Rollstuhlgerechter Zugang, Parkplatz und Sitzgelegenheit",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon (optional)",
        subject: "Betreff",
        message: "Ihre Nachricht",
        submit: "Nachricht senden",
        sending: "Senden …",
        success: "Vielen Dank — wir melden uns innerhalb eines Werktags.",
        error: "Etwas ist schiefgelaufen. Bitte rufen Sie uns an oder versuchen Sie es erneut.",
        privacy: "Mit dem Senden stimmen Sie zu, dass wir Ihre Angaben zur Bearbeitung der Anfrage verwenden.",
      },
    },
    footer: {
      tagline: "Bodenhandwerk seit 1985.",
      links_title: "Navigation",
      contact_title: "Kontakt",
      legal_title: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      copyright: "Pick Bodenbeläge GmbH — Schultenhofstraße 46, Mülheim a. d. Ruhr",
    },
  },

  en: {
    nav: {
      products: "Products",
      projects: "Projects",
      services: "Services",
      about: "About",
      contact: "Contact",
      cta: "Request consultation",
      home: "Home",
    },
    hero: {
      eyebrow: "Flooring · Mülheim an der Ruhr · Since 1985",
      title_l1: "Floors that",
      title_l2: "tell a room.",
      subtitle:
        "A family-run craft house for the Ruhr region — we advise, deliver and install parquet, vinyl, laminate and carpet with patient hands.",
      cta_primary: "Visit the showroom",
      cta_secondary: "Free consultation",
      scroll: "Scroll",
      slides: [
        { tag: "Parquet", title: "Real wood, born of the forest.", caption: "Oak · Ash · smoked tones" },
        { tag: "Vinyl & design floors", title: "Quiet, durable, stunning.", caption: "Water-resistant · click-lock · low-maintenance" },
        { tag: "Carpet", title: "Warmth beneath your feet.", caption: "Wool · sisal · made to measure" },
        { tag: "Laminate", title: "Character without compromise.", caption: "Premium HDF · AC5 rated" },
      ],
    },
    stats: {
      years: "Years of craft",
      projects: "Installed projects",
      rating: "Google rating",
      reviews: "Happy voices",
    },
    products: {
      eyebrow: "Range",
      title: "Five worlds beneath your feet.",
      subtitle:
        "From sturdy oak planks to plush wool carpets — everything in one place, curated for the Ruhr area.",
      items: [
        { name: "Parquet", desc: "Solid timber planks, oiled or lacquered. Precise installation included." },
        { name: "Vinyl", desc: "Water-resistant, quiet, indestructible. Kitchens, bathrooms, offices." },
        { name: "Laminate", desc: "Premium HDF core, AC5 classes, high-resolution decors." },
        { name: "Carpet", desc: "Broadloom and rugs. Wool, sisal, loop and high-pile." },
        { name: "Design floor", desc: "Mineral-reinforced. Authentic look, exceptional stability." },
      ],
      explore: "Explore the range",
    },
    marquee: ["Installation service", "Showroom advice", "Ruhr-wide delivery", "On-site measuring", "Sample service", "Care & repair"],
    services: {
      eyebrow: "What we do",
      title: "From first sketches to the final skirting board.",
      items: [
        {
          name: "Personal consulting",
          desc: "At our showroom on Schultenhofstraße 46 or at your home — we bring samples, plans and ideas.",
        },
        {
          name: "Measuring & planning",
          desc: "Documented to the millimetre. Honest calculations — no hidden square metres.",
        },
        {
          name: "Installation",
          desc: "In-house master craftsmen. Clean, on-time, with full site protection.",
        },
        {
          name: "Delivery",
          desc: "Across the Ruhr region. Delivered on schedule — or pick-up at the showroom.",
        },
        {
          name: "Care & repair",
          desc: "Sanding, oiling, individual plank replacement — we extend your floor's life.",
        },
        {
          name: "Accessibility",
          desc: "Wheelchair-friendly entrance, parking and seating — advice for everyone.",
        },
      ],
    },
    gallery: {
      eyebrow: "Projects",
      title: "Rooms we were proud to shape.",
      subtitle: "Selected installations from Mülheim, Duisburg, Essen and Oberhausen.",
      filter_all: "All",
    },
    testimonials: {
      eyebrow: "Reviews",
      title: "4.5 of 5 — across 220 Google reviews.",
      items: [
        {
          name: "M. Schäfer",
          role: "Private client, Mülheim",
          text: "Personal advice, a fair offer and a dream installation team. Our oak parquet is a stunner.",
        },
        {
          name: "Architekturbüro Vogel",
          role: "Business client",
          text: "Punctual, clean, precise. We recommend Pick Bodenbeläge for every Ruhr-area project.",
        },
        {
          name: "Family K.",
          role: "Period home renovation",
          text: "Finally a shop with real advice. Instead of off-the-shelf, we got exactly the right floor.",
        },
        {
          name: "Café Kleinod",
          role: "Hospitality",
          text: "Design floor that holds up to a daily crowd. The crew worked overnight — we never closed.",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk about your floor.",
      address_label: "Showroom",
      address: "Schultenhofstraße 46\n45475 Mülheim an der Ruhr, Germany",
      phone_label: "Phone",
      phone: "+49 208 73068",
      hours_label: "Opening hours",
      hours: "Mon–Fri · 09:00 – 18:00\nSat · 10:00 – 14:00",
      access_label: "Accessibility",
      access: "Wheelchair-accessible entrance, parking and seating",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone (optional)",
        subject: "Subject",
        message: "Your message",
        submit: "Send message",
        sending: "Sending …",
        success: "Thanks — we'll respond within one business day.",
        error: "Something went wrong. Please call us or try again.",
        privacy: "By sending, you agree we may use your details to respond to your request.",
      },
    },
    footer: {
      tagline: "Floor craftsmanship since 1985.",
      links_title: "Navigate",
      contact_title: "Contact",
      legal_title: "Legal",
      imprint: "Imprint",
      privacy: "Privacy",
      copyright: "Pick Bodenbeläge GmbH — Schultenhofstraße 46, Mülheim a. d. Ruhr",
    },
  },
};
